<span *ngIf="canUse">
<a href="" class="option-trash" (click)="removeOption(); false;"><i class="fa fa-trash"></i></a>
</span>
